var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddHomeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: 444444,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M704.62-204.62h30.76v-100h100v-30.76h-100v-100h-30.76v100h-100v30.76h100v100ZM720-160q-66.85 0-113.42-46.58Q560-253.15 560-320t46.58-113.42Q653.15-480 720-480t113.42 46.58Q880-386.85 880-320t-46.58 113.42Q786.85-160 720-160Zm-520-80v-420l280-211.54L760-660v72.77q-9.77-2.15-19.68-2.85-9.91-.69-20.32-.69V-640L480-821.54 240-640v360h212.23q1.27 10.5 3.81 20.5t6.34 19.5H200Zm280-310.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHomeIc);
export default __webpack_public_path__ + "static/media/add_home_ic.dc0ef9852788ef97a0eac1e81bc76b79.svg";
export { ForwardRef as ReactComponent };